module.exports = __webpack_public_path__ + "static/media/Path 13.9aeb49ce.png";